import { VideoContainer } from '@/components/video-container';

import { VideoPlayerVod } from '@/components/video-player';
import { useMuxSrcConstructor } from '@/hooks/useMuxSrcConstructor';

import {
  Box,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import C from '../../../../../shared/constants/general';

import EventDescription from '../../../shared/components/info/EventDescription';
import { getEventPlaceInProgram } from '../../../shared/utils/Sorters';
import { getDurationHM } from '../../../shared/utils/StringFormat';
import { EventContext } from '../../context/EventContext';
import { useTrack } from '@/js/shared/context/CoeolyticsHooks';
import { DateUtils } from '../../../shared/utils/dateUtils';
import EventNavigation from '../info/EventNavigation';
import EventStartEditor from '../info/EventStartEditor';
import queryString from 'query-string';
import EventNavigationSmallScreen from '../info/EventNavigationSmallScreen';

const useStyles = makeStyles((theme) => ({
  emptyPlayer: {
    position: 'relative',
    width: '100%',
    backgroundColor: '#222',
    height: 0,
    padding: '0 0 56.25% 0',
  },
  noPlayer: {
    position: 'relative',
    width: '100%',
    backgroundColor: '#222',
    height: 110,
  },
  playerStyle: {
    position: 'relative',
    width: '100%',
    backgroundColor: '#000000',
    color: '#fff',
  },
  playerStyleText: {
    color: '#fff',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  videoHolder: {},
  infoHolder: {
    backgroundColor: '#fff',
  },
  videoBoxHolder: {
    overflow: 'hidden',
  },
  videoBoxHolderSmallscreen: {
    width: '100%',
  },
  videoNavHolder: {
    position: 'relative',
    overflow: 'hidden',
  },
  videoHtmlHolder: {
    ' button': {
      outline: 'none!important',
    },
  },
  descriptionFullscreen: {
    overflowY: 'auto',
  },
  discussionContainer: {
    borderRadius: 5,
    backgroundColor: theme.palette.background.shadedown_10,
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  left: {
    flexGrow: 1,
    overflow: 'auto',
    height: 'calc(100vh - 48px)',
    minHeight: 'calc(100vh - 48px)',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    /*backgroundColor: 'green',*/
  },
  right: {
    overflow: 'auto',
    minWidth: '300px',
    width: '300px',
    height: 'calc(100vh - 48px)',
    minHeight: 'calc(100vh - 48px)',
    backgroundColor: theme.palette.background.shadedown_20,
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));

const EventDashboard = (props) => {
  const classes = useStyles();
  const track = useTrack();

  const { eventState, actions } = useContext(EventContext);

  // const [selectedVideo] = useState(0);
  const [placeInList, setPlaceInList] = useState(null);
  const [timeReactions] = useState([]);
  const [replayStatus, setReplayStatus] = useState('');
  const [activeVideoAsset, setActiveVideoAsset] = useState(null);
  const [localEvent, setLocalEvent] = useState(null);
  const [activeEvent, setActiveEvent] = useState(null);
  const [utctimeplayer, setUtctimeplayer] = useState(0);
  const [starttime, setStartTime] = useState(0);
  const [editEvent, setEditEvent] = useState(null);
  const qs = queryString.parse(props.location.search);
  const [activeToken, setActiveToken] = useState(null);
  const [individualTokens, setIndividualTokens] = useState(null);
  const [individualStoryboardTokens, setIndividualStoryboardTokens] = useState(
    null
  );
  // const [activeStoryboardToken, setActiveStoryboardToken] = useState(null);
  const [activeStoryboardUrl, setActiveStoryboardUrl] = useState(null);
  const [activeCaptions, setActiveCaptions] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const [source, setSource] = useState(null);

  var newFullEventLoad = React.useRef(false);
  const [ended, setEnded] = useState(null);

  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'), {
    noSsr: true,
  });

  //This will add stuff to the state (by reference, will not cause useeffect to be runned)
  const SetupData = (event) => {
    const eventdate = event.programDay.date;
    //const offset = event.programDay.conference.utc_offset; //Sweden
    const timezone = event.programDay.conference.timezone;
    event.programRoom.events = event.programRoom.events.map((ev) => {
      const videoassets = event.programRoom.programroomvideoassets;
      let possible_assets = []; //If assets exist
      let utcdatestring = eventdate + 'T' + ev.start_time + '.000Z';
      let unixtimestamp_milliseconds = new Date(utcdatestring).getTime();

      //Milliseconds to seconds
      let unixtimestamp = parseInt(
        (unixtimestamp_milliseconds / 1000).toFixed(0)
      );
      const offset = DateUtils.getOffsetByTimezone2(
        timezone,
        unixtimestamp_milliseconds
      ); //get offset by conference timezone and date of event

      let utc_offest_hours = offset / 60; //Sweden for example, utc+2,
      let event_start_unixtimestamp_offset_compensated =
        unixtimestamp + 3600 * utc_offest_hours;
      let user_event_start_adjustment_sec = ev.adjusted_start_offset;
      let event_start_with_compensation =
        event_start_unixtimestamp_offset_compensated +
        user_event_start_adjustment_sec;

      //Starttimedate_utc will now have offset compensation added to it.
      ev['starttimedate_utc'] = event_start_with_compensation;
      for (let i = 0; i < videoassets.length; i++) {
        //deep copy
        const tmp_videoasset = videoassets.map((item) => ({ ...item }));
        //Select from assetst that have end time larger start of event
        if (tmp_videoasset[i].recording_end >= event_start_with_compensation) {
          let start_offest_seconds = parseInt(
            event_start_with_compensation - tmp_videoasset[i].recording_start
          );
          tmp_videoasset[i].start_offest_seconds = start_offest_seconds;
          possible_assets.push(tmp_videoasset[i]);
        }
      }
      ev.possible_assets = possible_assets;
      if (possible_assets.length > 0) {
        let earliest_event_of_possible = possible_assets.reduce(function (
          prev,
          curr
        ) {
          return prev.recording_start < curr.recording_start ? prev : curr;
        });
        ev.start_asset = earliest_event_of_possible;
      } else {
        console.log('No possible asset for this event', ev);
        ev.start_asset = null;
      }
      return ev;
    });

    return event;
  };

  useEffect(() => {
    if (eventState.eventLoaded && eventState.event) {
      setSource(null);
      //Setup data
      const event = SetupData(eventState.event);
      console.log('event', event);
      actions.setEvent(event);
      setLocalEvent(event);
      setShowVideo(
        event.programRoom.video_state === C.PROGRAM_ROOM.VIDEO_STATE.FILE
      );
      if (event.programRoom.video_state !== C.PROGRAM_ROOM.VIDEO_STATE.FILE) {
        setReplayStatus('session_in_progress');
      }
      let utcp = utctimeplayer;
      console.log(
        'activeevent before event.programRoom.events',
        event.programRoom.events
      );
      let activeevent = event.programRoom.events.find((x) => x.id === event.id);

      const placeInfo = getEventPlaceInProgram(
        event.programRoom.events,
        event.id
      );
      setPlaceInList(placeInfo);
      if (
        event.programRoom.programroomvideoassets.length === 0 ||
        event.type === C.EVENT.TYPE.ACTIVITY
      ) {
        setStartTime(0);
        setActiveVideoAsset(null);
        console.log('setActiveEvent1');
        setActiveEvent(activeevent);
        setReplayStatus('no_event_recording');
      } else {
        if (event.programRoom.programroomvideoassets.length > 0) {
          setReplayStatus('show');
          if (activeevent.start_asset) {
            //New button load
            if (newFullEventLoad.current == true) {
              setStartTime(
                activeevent.start_asset.start_offest_seconds + Math.random()
              );
              setActiveVideoAsset(activeevent.start_asset);
              console.log('setActiveEvent2');
              setActiveEvent(activeevent);
              track('VOD REPLAY', {
                session: activeevent.title,
              });
              newFullEventLoad.current = false;
              return;
            } else {
              if (utcp <= 0) {
                //Page load, kind of uggly to get to load.
                setStartTime(
                  activeevent.start_asset.start_offest_seconds + Math.random()
                );
                setActiveVideoAsset(activeevent.start_asset);
                console.log('setActiveEvent3');
                setActiveEvent(activeevent);
                track('VOD REPLAY', {
                  session: activeevent.title,
                });
                return;
              } else {
                //Scrubb load
                if (utcp > activeevent.start_asset.recording_end) {
                  console.log('setActiveEvent4');
                  setActiveEvent(activeevent);
                  return;
                } else {
                  //Scrubb in range of same event asset
                  setStartTime(utcp - activeevent.start_asset.recording_start);
                  setActiveVideoAsset(activeevent.start_asset);
                  console.log('setActiveEvent5');
                  setActiveEvent(activeevent);
                  return;
                }
              }
            }
          } else {
            console.log('no asset can be found for this event', activeevent);
          }
        } else {
          setReplayStatus('no_session_recording');
        }
      }
      //newFullEventLoad.current = false;

      return () => {};
    }
  }, [eventState.eventLoaded, eventState?.event?.id]);

  useEffect(() => {
    if (activeVideoAsset) {
      let token = individualTokens.find(
        (x) =>
          x.mux_asset_playback_id === activeVideoAsset.mux_asset_playback_id
      );

      setActiveToken(token.token);
      let storyboardtoken = individualStoryboardTokens.find(
        (x) =>
          x.mux_asset_playback_id === activeVideoAsset.mux_asset_playback_id
      );
      // setActiveStoryboardToken(storyboardtoken.token);
      setActiveStoryboardUrl(
        `https://image.mux.com/${activeVideoAsset.mux_asset_playback_id}/storyboard.vtt?token=${storyboardtoken.token}`
      );
      setActiveCaptions(activeVideoAsset.subtitles);
    } else {
      setActiveToken(null);
      setActiveStoryboardUrl(null);
      setActiveCaptions(null);
    }
  }, [activeVideoAsset?.id]);

  //run once, eventState is loaded at this point.
  useEffect(() => {
    setIndividualTokens(eventState.event.individualTokens);
    setIndividualStoryboardTokens(eventState.event.individualStoryboardTokens);
    track('VOD REPLAY ROOM', {
      programroom: eventState.event.programRoom.title,
    });
  }, []);

  //Callback
  const goToEvent = (eventid) => {
    newFullEventLoad.current = true;
    actions.loadEventDetail(eventid, true);
  };
  console.log('localEvent', localEvent);
  console.log('activeEvent', activeEvent);
  useEffect(() => {
    if (qs.edit && activeEvent) {
      console.log('editevent', editEvent);
      setEditEvent(activeEvent);
    }
  }, [qs.edit, activeEvent?.id]);

  const findEventByUtcTime = (utctime) => {
    //Sort events by starttimedate_utc
    let sortedEvents = [...localEvent.programRoom.events].sort((a, b) =>
      a.starttimedate_utc > b.starttimedate_utc
        ? 1
        : b.starttimedate_utc > a.starttimedate_utc
        ? -1
        : 0
    );
    console.log('sortedEvents', sortedEvents);

    //Get all events that har start time before players utc time
    let found = null;
    let possible_events = sortedEvents.filter((event) => {
      return event.starttimedate_utc <= utctime;
    });

    const largest_recording_start = possible_events.sort(
      (a, b) => a.starttimedate_utc - b.starttimedate_utc
    );

    found = largest_recording_start[largest_recording_start.length - 1];
    console.log('found', found);

    if (found) {
      return found;
    } else {
      //Return first event when no match. Neede to support playing video before starttime
      return sortedEvents[0];
    }
  };
  console.log('newFullEventLoad', newFullEventLoad.current);
  const checkForEventChange = (utctime) => {
    if (qs.edit) {
      return;
    }
    //Block update during load
    if (newFullEventLoad.current == true) {
      return;
    }
    //Block update during load
    if (eventState.eventProgress !== false) {
      return;
    }

    let foundevent = findEventByUtcTime(Math.ceil(utctime));
    console.log('foundevent', foundevent);
    if (foundevent && activeEvent.id != foundevent.id) {
      track('VOD REPLAY', {
        session: foundevent.title,
      });
      console.log('seek call hoise');
      newFullEventLoad.current = true;
      actions.loadEventDetail(foundevent.id, true);
    }
  };

  //Useeffect for utctimeplayer, updates on callback from player
  useEffect(() => {
    if (utctimeplayer <= 0) {
      return;
    }
    if (newFullEventLoad.current == true) {
      return;
    }
    //Block update during load
    if (eventState.eventProgress !== false) {
      return;
    }
    if (localEvent.id !== eventState.event.id) {
      return;
    }
    //Urly hack for not playout video that starts before first event
    if (!qs.edit) {
      //Assume that the events are sorted by time
      console.log('eventState.event.programRoom.events', eventState.event);
      const starttimeoffirstevent =
        localEvent.programRoom.events[0].starttimedate_utc;
      console.log('starttimeoffirstevent', starttimeoffirstevent);

      if (utctimeplayer <= starttimeoffirstevent) {
        console.log('if block ee dhukhse');
        if (localEvent.programRoom.events[0].start_asset) {
          setStartTime(
            localEvent.programRoom.events[0].start_asset.start_offest_seconds +
              Math.random()
          );
          return;
        }
      }
    }
    //END UGLY
    console.log('utctimeplayer', utctimeplayer);
    checkForEventChange(utctimeplayer);
  }, [utctimeplayer]);

  useEffect(() => {
    //Run when videoplayer gets to the end.
    if (ended) {
      //Select next asset to play
      var larger_endtime = activeEvent.possible_assets.filter((asset) => {
        return asset.recording_end > activeVideoAsset.recording_end;
      });
      const asset_sorted_by_lowest_recording_start = larger_endtime.sort(
        (a, b) => a.recording_start - b.recording_start
      );
      if (asset_sorted_by_lowest_recording_start.length > 0) {
        setStartTime(0); //Start at 0 when file playout in case of ended.
        setActiveVideoAsset(asset_sorted_by_lowest_recording_start[0]);
      }
    }
  }, [ended]);

  //Callback from player
  const playerEvents = (event, utctime) => {
    //Time comes back from player as as utc timestamp
    if (event === 'timeupdate') {
      setUtctimeplayer((prev) => {
        //Audio glitch fix when swapping.
        if (Math.abs(utctime - prev) > 1) {
          return utctime;
        } else {
          return prev;
        }
      });
    }
    //When player end play next asset if exist
    if (event === 'ended') {
      //setEnded(utctime);
      //Set random number to force reload of next video asset.
      setEnded(Math.random());
      return;
    }
  };

  useEffect(() => {
    if (
      replayStatus === 'show' &&
      activeVideoAsset?.id &&
      activeToken &&
      activeEvent?.start_asset
    ) {
      const source = useMuxSrcConstructor({
        posterUrl: `/api/redirect_mux_image/${activeEvent.start_asset.mux_asset_playback_id}/thumb/${activeEvent.start_asset.start_offest_seconds}`,
        srcToken: activeToken,
        playbackId: activeVideoAsset.mux_asset_playback_id,
      });
      setSource(source);
    }
  }, [replayStatus, activeVideoAsset?.id, activeToken, activeEvent?.id]);

  console.log('editEvent', editEvent);
  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.left}>
          {activeEvent ? (
            <div>
              <VideoContainer
                displayBackdrop={'show' !== replayStatus}
                backdrop="none"
                maxHeight="56.25%"
              >
                {replayStatus === 'show' && source && (
                  <VideoPlayerVod
                    source={source}
                    storyBoardUrl={activeStoryboardUrl}
                    videoAssetStartUTC={activeVideoAsset.recording_start}
                    videoStartTime={starttime}
                    playerEventCallback={playerEvents}
                    captions={activeCaptions}
                  />
                )}
                {replayStatus === 'no_event_recording' && (
                  <Typography
                    variant="body2"
                    align="center"
                    color="textPrimary"
                  >
                    No recording for this session.
                  </Typography>
                )}
                {replayStatus === 'session_in_progress' && (
                  <Typography
                    variant="body2"
                    align="center"
                    color="textPrimary"
                  >
                    No video yet.
                    <br />
                    Come back right after event to watch replay!
                  </Typography>
                )}
                {replayStatus === 'no_session_recording' && (
                  <Typography
                    variant="body2"
                    align="center"
                    color="textPrimary"
                  >
                    No video yet.
                    <br />
                    Come back right after event to watch replay!
                  </Typography>
                )}
              </VideoContainer>
              {qs.edit && editEvent?.id && (
                <EventStartEditor
                  key={editEvent.id}
                  event={editEvent}
                  playerPositionUtc={utctimeplayer}
                />
              )}
              {smallScreen && (
                <EventNavigationSmallScreen
                  events={eventState.event.programRoom.events}
                  goToEventCallback={goToEvent}
                  selectedEvent={activeEvent}
                />
              )}
              <Box p={1}>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={12}>
                    <EventDescription
                      //current={props.location.search.indexOf('current') > -1}
                      event={eventState.event}
                      /*nextEventId={
                        placeInList &&
                        !placeInList.isLast &&
                        placeInList.eventAfter &&
                        placeInList.eventAfter.id
                      }*/
                      timeReactions={timeReactions}
                      videoLength={
                        showVideo &&
                        placeInList &&
                        getDurationHM(placeInList.videoLength)
                      }
                    />
                  </Grid>

                  {/* <Grid item xs={12} lg={6}>
                    {!window.SETTINGS.NEW_DISCUSSION_MODERATE && (
                      <Box p={1} className={classes.discussionContainer}>
                        <DiscussionList
                          listType="connection"
                          location={props.location}
                          history={props.history}
                          isEmbedded={true}
                          connectionType="event"
                          connectionId={eventState.event.id}
                          hideMenu={true}
                          title={'Session forum'}
                        />
                      </Box>
                    )}
                  </Grid> */}
                </Grid>
              </Box>
            </div>
          ) : (
            <VideoContainer>
              <Box>
                <Typography variant="subtitle2" color="error" gutterBottom>
                  Could not load event
                </Typography>
              </Box>
            </VideoContainer>
          )}
        </div>
        {!smallScreen && activeEvent && (
          <div className={classes.right}>
            <EventNavigation
              events={eventState.event.programRoom.events}
              assetCount={
                eventState.event.programRoom.programroomvideoassets.length
              }
              selectedEvent={activeEvent}
              goToEventCallback={goToEvent}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default EventDashboard;
